import Axios, { Response } from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type signUpFirstType = {
  id: string;
  password: string;
  full_name: string;
  business_name: string;
  business_number: string;
  phone_number: string;
  email: string;
};
export type signUpType = {
  signup_id: number;
  signup_url: string;
};
export type signUpCheckList = {
  signup_id: number;
};
export type findForgetIdAuthDataType = {
  user_name: string;
  phone_number: string;
};
export type findForgetPwdAuthDataType = {
  id: string;
  phone_number: string;
};
export type authNumVerifyDataType = {
  user_name: string;
  phone_number: string;
};
export type changePwdByfindPwdDataType = {
  id: string;
  password: string;
  password_check: string;
  key: number;
  store_id: number;
};

const LoginController = {
  staff: {},

  /**
   *  * URL: "/signIn"
   *
   *  * 기능:
   *      * 1. 서버 로그인
   *      * 2. "token","refresh-token","user_token_id"를 asyncStorage 저장
   *      * 3. auth data를 recoil에 저장한다.
   *
   */
  signIn: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/auth/signin';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 회원가입
  signUpFirst: async (signUpList: signUpFirstType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/knock/signUpFirst';
      const response: any = await Axios.post(sUrl, signUpList);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 회원가입 서명 이미지 업로드
  upload: async (image: any, storeId: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/upload`;
      const store_id = storeId;
      console.log('storeId===>', storeId);
      const response: any = await Axios.multipartPost(sUrl, image, store_id, 'contract_sign_img');

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[전자서명 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // 회원가입 서명인증 확인
  signUpCheck: async (signUpCheckList: signUpCheckList) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/knock/signUpCheck';
      const response = await Axios.post(sUrl, signUpCheckList);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 서명인증 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 회원가입 최종 인증
  signUp: async (signUpList: signUpType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/knock/signUp';
      const response = await Axios.post(sUrl, signUpList);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 회원가입 카카오톡 인증번호
  signUpPhoneAuth: async (userPhoneNumber: string) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/signUpPhoneAuth';
      const response: any = await Axios.post(sUrl, userPhoneNumber);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 휴대폰 인증 오류]' + oErr.toString(),
        data: {},
      };
    }
  },

  // 중복 아이디 체크
  // checkDupId: async (userId: string) => {
  //   try {
  //     let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/checkDupId/:' + userId;

  //     const response: any = await Axios.get(sUrl);
  //     return response;
  //   } catch (err) {
  //     let oErr: any = err;
  //     return {
  //       ok: false,
  //       msg: '[아이디 중복 오류]' + oErr.toString(),
  //       data: {},
  //     };
  //   }
  // },

  // 아이디 찾기
  findForgetIdAuth: async (findForgetIdAuthData: findForgetIdAuthDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/findId';
      const response: any = await Axios.post(sUrl, findForgetIdAuthData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디 찾기 정보 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 비밀번호 찾기
  findForgetPwdAuth: async (findForgetPwdAuthData: findForgetPwdAuthDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/findPw';
      const response: any = await Axios.post(sUrl, findForgetPwdAuthData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[비밀번호 찾기 정보 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 아이디 찾기/비밀번호 찾기_카카오톡 인증번호
  authNumVerify: async (authNumVerifyData: authNumVerifyDataType[],path:string) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/auth/${path}`;
      const response: any = await Axios.post(sUrl, authNumVerifyData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디찾기/비밀번호찾기 휴대폰 인증번호 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 비밀번호 변경
  changePwdByfindPwd: async (changePwdByfindPwdData: changePwdByfindPwdDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/changeUserPassword';
      const response: any = await Axios.post(sUrl, changePwdByfindPwdData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[비밀번호 변경 오류]' + oErr.toString(),
        data: null,
      };
    }
  },

  // firebase token
  setWebFirebaseToken: async (oParams: any) => {
    try {
      console.log('oParams', oParams);
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/user/setHotelierFirebaseToken`;

      const response: any = await Axios.post(sUrl, oParams);
      console.log('setHotelierFirebaseToken', response);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[Firebase Token 오류]' + oErr.toString(),
        data: null,
      };
    }
  },
  // logout
  logout: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/user/logout`;

      const response: any = await Axios.post(sUrl, oParams);
      console.log('logout', response);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그아웃 오류]' + oErr.toString(),
        data: null,
      };
    }
  },
  logToServer: async (oData: any) => {
    let oPost = {
      log: JSON.stringify(oData),
    };
    // UtilController.logToServer(oPost)
  },
};

export default LoginController;
